import React from 'react';

import Logo from '../../../../assets/Logo-tight-white.png';
import { Typography, Box } from '@mui/material';

const Mastermind = () => {
  return (
    <Box
      sx={{
        mt: '6rem',
        textAlign: 'center',
        width: { xs: '90%', sm: '80%', xl: '65%' },
        maxWidth: '1200px',
        mx: 'auto',
      }}>
      <Typography
        variant='h4'
        component='h2'
        sx={{
          fontWeight: 'bold',
          maxWidth: { xs: '100%', sm: '60%' },
          mx: 'auto',
          mb: '2rem',
        }}>
        Member Benefits
      </Typography>
      <div className='max-w-sm mx-auto grid gap-6 md:grid-cols-2 lg:grid-cols-3 items-start md:max-w-2xl lg:max-w-none'>
        {/* 1st item */}
        <div className='relative flex flex-col items-center justify-center p-10 bg-primary-main rounded shadow-xl h-full'>
          <img src={Logo} alt={'logo'} style={{ maxWidth: '70%', maxHeight: '200px' }} />
        </div>
        {/* 2nd item */}
        <div className='relative flex flex-col items-left text-left p-8 bg-white rounded shadow-xl h-full'>
          <h4 className='text-2xl font-bold mb-1'>Monthly Masterminds</h4>
          <p className='text-lg font-montreal leading-snug'>
            A group of 8 founders we match with an executive facilitator, that meets every month to discuss personal and
            business problems.
          </p>
        </div>
        <div className='relative flex flex-col items-left text-left p-8 bg-white rounded shadow-xl h-full'>
          <h4 className='text-2xl font-bold mb-1'>Digital Community</h4>
          <p className='text-lg font-montreal leading-snug'>
            Access to a telegram group of highly engaged founders who provide helpful advice, a dedicated digital
            concierge, and online membership portal.
          </p>
        </div>{' '}
        <div className='relative flex flex-col items-left text-left p-8 bg-white rounded shadow-xl h-full'>
          <h4 className='text-2xl font-bold mb-1'>In-Person Community</h4>
          <p className='text-lg font-montreal leading-snug'>
            Our in-person event strategy is focused around three pillars: monthly modern events, monthly teh peng chats,
            and annual adventures.
          </p>
        </div>{' '}
        <div className='relative flex flex-col items-left text-left p-8 bg-white rounded shadow-xl h-full'>
          <h4 className='text-2xl font-bold mb-1'>Speakers & Education</h4>
          <p className='text-lg font-montreal leading-snug'>
            We know how important it is to have access to the best and brightest. So, we host unique workshops and bring
            in experts across a variety of topics.
          </p>
        </div>{' '}
        <div className='relative flex flex-col items-left text-left p-8 bg-white rounded shadow-xl h-full'>
          <h4 className='text-2xl font-bold mb-1'>Exclusive Perks</h4>
          <p className='text-lg font-montreal leading-snug'>
            All members who join us get a smart 100Card, which they can use at select locations throughout Singapore for
            exclusive discounts.
          </p>
        </div>
      </div>
    </Box>
  );
};

export default Mastermind;
